import { useCallback } from 'react';

/**
 * Hook para imprimir a página atual.
 * Centraliza a lógica de impressão para ser reutilizada em qualquer componente.
 */
export const usePrintPage = (): (() => void) => {
  return useCallback((): void => {
    window.print();
  }, []);
};

export default usePrintPage;
